import React from "react";
import { Link } from "react-router-dom";
import HeroSection from "./HeroSection";
import Header from "./Header";
import MainContent from "./MainContent";
import TeamSection from "./TeamSection";
import Footer from "./Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white text-black">
      <HeroSection />
      <Header />
      <MainContent />
      <TeamSection />
      <section className="px-4 md:px-8" style={{ paddingTop: 'clamp(24px, 4vw, 32px)', paddingBottom: 'clamp(24px, 4vw, 32px)', backgroundColor: '#f2f2f2' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
          <Link
            to="/referenzen"
            style={{
              backgroundColor: '#000000',
              color: '#ffffff',
              padding: '16px 48px',
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              fontSize: 'clamp(16px, 3.5vw, 19.2px)',
              fontWeight: 400,
              textDecoration: 'none',
              display: 'inline-block',
              borderRadius: 0,
            }}
          >
            Referenzen
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;